module.exports = __webpack_public_path__ + "static/media/fabrica-biscoitos.8a5a8386.webp";